import { AMIDE_COUPLING_CONDITION_GROUPS } from './reaction-classes/amide-coupling';
import { BUCHWALD_HARTWIG_CONDITION_GROUPS } from './reaction-classes/buchwald-hartwig';
import { SUZUKI_CONDITION_GROUPS } from './reaction-classes/suzuki';
import { WATER_BUCHWALD_HARTWIG_CONDITION_GROUPS } from './reaction-classes/water-buchwald-hartwig';

export const REACTION_CLASSES = {
  SUZUKI: {
    name: 'Suzuki',
    conditions: SUZUKI_CONDITION_GROUPS,
  },
  AMIDE_COUPLING: {
    name: 'Amide Coupling',
    conditions: AMIDE_COUPLING_CONDITION_GROUPS,
  },
  BUCHWALD_HARTWIG: {
    name: 'Buchwald-Hartwig',
    conditions: BUCHWALD_HARTWIG_CONDITION_GROUPS,
  },
  WATER_BUCHWALD_HARTWIG: {
    name: 'Water Buchwald-Hartwig',
    conditions: WATER_BUCHWALD_HARTWIG_CONDITION_GROUPS,
  },
} as const;

export type ReactionClassName = keyof typeof REACTION_CLASSES;
export type ConditionGroup = (typeof REACTION_CLASSES)[ReactionClassName]['conditions'][number];
